import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  startParse as startParseAction,
  getSettingList as getSettingListAction,
  updateByKey as updateByKeyAction,
} from "../../redux/modules/settings";

import OrderConstant from "../../constants/OrderConstant";

import UiPageText from "../../components/text/UiPageText";
import UiInputText from "../../components/inputs/UiInputText";
import UiButtonColor from "../../components/button/UiButtonColor";

import "./SettingStyle.scss";

function SettingPage(props) {
  useEffect(() => {
    if (props.login.user) props.getSettingList();
  }, [props.login.user]);

  let list = props.settings.list.map((item, index) => {
    return (
      <UiInputText
        key={index}
        placeholder={item.value}
        label={`${item.description} (Если стоить 0 значит ВЫКЛЮЧЕНО )`}
        onBlur={(val) => {
          props.updateByKey(item.text, val);
        }}
      />
    );
  });

  return (
    <div id="page" className="home-page">
      <section className="home-info ui-grid">
        <div className="home-info-text">
          <UiPageText title="Настройки" />
        </div>
      </section>
      {console.log(props.settings.pricesObjects)}

      <section className="page-content">
        <UiButtonColor
          color="gray"
          text="Синхронизировать цены и новые товары"
          small={true}
          onClick={() => {
            props.startParse();
            alert("Синхронизация запущена. Через некоторое время процесс завершиться.");
          }}
        />

        
      </section>

      <section className="page-content">{list}</section>
    </div>
  );
}

export default connect(({ login, settings }) => ({ login, settings }), {
  startParse: startParseAction,
  getSettingList: getSettingListAction,
  updateByKey: updateByKeyAction,
})(SettingPage);
